import React, {useState, useEffect} from 'react';
import 'moment-timezone';
import axios from 'axios';
import axiosUrl from '../../axios/url';
import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';

const arrWeek = ['', '월','화','수','목','금','토','일'];

export default function ScheduleTable(param) {

    const [scheduleList, setScheduleList] = useState([]);
    const [programId, setProgramId] = useState("-1");

    // schedule 목록 조회
    async function getScheduleList(programId, type){
        await axios.get(axiosUrl.schedule_list + "/" + programId + "/schedules?type=" + type)
        .then( response => {
            // old value, new value를 비교하여 변화가 있을 때만, rendering함. 이 로직을 빼면 무한 렌더링에 빠짐.
            if(JSON.stringify(scheduleList) != JSON.stringify(response.data)) { 
                //" "기준으로 string 문자 배열로 변경(representive을 보여주기 위하여)
                response.data.map((schedule, i) => {
                    var temp = schedule.representives.split(",");
                    response.data[i].representiveList = temp
                })
                setScheduleList(response.data);
                console.log("schedule list success");
            }
        })
        .catch(function (e) {
                console.error('[MEDIEX_CMS_2019_ERROR] Project.getScheduleList - ' + e);
                console.error('[MEDIEX_CMS_2019_ERROR] axiosUrl - ' + axiosUrl.project_list);
        });

    }

    useEffect(() => {
        if(param.programId !== "") {
            getScheduleList(programId, param.type);
        }
    }, [param.type]);

    useEffect(() => {
        if(param.programId !== "") {
            setProgramId(param.programId);
            getScheduleList(param.programId, param.type); //"WEEK"
        } else {
            setScheduleList([]);
        }
    }, [param.programId])

    function ScheduleClick(id) {
        param.callbackScheduleId(id);
        param.callbackWrapperCheck(true);
    }
    
    function renderItems(){
        if(scheduleList.length > 0) {
            return scheduleList.map((schedule, i) => (
                <tr key={i}>
                    <td>
                        {/* WEEK, DAY, WEEKDAY, EVENT, RESERVED */}
                        {schedule.type == 'WEEK' &&
                            schedule.week + '주차 ' + arrWeek[schedule.weekday] + '요일 ' + schedule.hour + '시 ' + schedule.minute + '분'
                        }
                        {schedule.type == 'DAY' &&
                            schedule.day + '주차 ' + schedule.hour + '시 ' + schedule.minute + '분'
                        }
                        {schedule.type == 'WEEKDAY' &&
                            arrWeek[schedule.weekday] + '요일 ' + schedule.hour + '시 ' + schedule.minute + '분'
                        }
                        {schedule.type == 'EVENT' &&
                            schedule.eventValue
                        }
                        {schedule.type == 'RESERVED' &&
                            schedule.dateReserved
                        }
                    </td>
                    <td>
                        {/* 데이터 픽커 문제로 a태그를 사용 */}
                        {/* <a href={"/schedulemodify/" + param.type + "/" +param.projectId +  "/" +programId+ "/" +schedule.id}> */}
                        <a >
                            <div className="grid">
                                <div className="text-line" onClick={() => ScheduleClick(schedule.id)}>
                                    {schedule.title}
                                </div>
                            </div>
                            <div className="pb-1">
                                {schedule.representiveList.map((tag, i) => (
                                    <button key={i} className="btn btn-default rounded-circle-h bg-olive disabled btn-sm ml-1">{tag}</button>    
                                ))}
                            </div>
                        </a>
                    </td>
                </tr>
            ))
        }else{
            return(
                <tr>
                    <td  className="cursor-pointer" valign="middle" align="center" colSpan="2" >조회할 콘텐츠가 없습니다.</td>
                    <td className="d-none"></td>
                </tr>
            )
        }
    }

    return(
        <table id="scheduleDtaTable" className="table table-hover">
            <thead align="center">
                <tr>
                    <th className="w-25">시점</th>
                    <th>제목</th>
                </tr>
            </thead>
            <tbody align="center">
                {renderItems()}
            </tbody>
            <tfoot></tfoot>
        </table>
        
    );
}

ScheduleTable.propTypes = {
    type: PropTypes.string,
    programId: PropTypes.string
  };